/** Axios Setup */
import axios, {AxiosError} from "axios";
import useState from "./store";
import router from "./router";
import {useToast} from "primevue/usetoast";
import {useConfirm} from "primevue/useconfirm";

let localToast: ReturnType<typeof useToast>;
let localConfirm: ReturnType<typeof useConfirm>;

const setupComponent = (
    toast: ReturnType<typeof useToast>,
    confirmation: ReturnType<typeof useConfirm>
) => {
    localToast = toast;
    localConfirm = confirmation;
};

const setAxiosBearer = () => {
    axios.defaults.headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${useState().value.token ?? ""}`,
    };
};

setAxiosBearer();

// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response.status === 401) {
//       // store.commit("SET_TOKEN", "");
//       // store.commit("SET_USERNAME", "");
//       router.replace({ name: "Login" });
//       throw Error("Session หมดอายุ กรุณาเข้าสู่ระบบ ใหม่อีกครั้ง");
//     } else if (error.response.status === 404) {
//       throw Error("ไม่สามารถดึงข้อมูลได้ (404)");
//     } else {
//       throw Error(error.response.data.title ?? error.response.data);
//     }
//   }
// );

axios.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        console.log(JSON.stringify(error));
        if (error.response?.status === 401) {
            onLogout();
            if (error.response?.data !== null)
                error.response.data = {
                    title: "session หมดอายุกรุณา Login ใหม่อีกครั้ง",
                };
            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    }
);
//Vue Analytics
// import VueAnalytics, { page, set } from "vue-analytics";
// Vue.use(VueAnalytics, { id: process.env.VUE_APP_GA_TAG });
// import VueGTag, { set } from "vue-gtag";
// Vue.use(VueGTag, { config: { id: process.env.VUE_APP_GA_TAG } });

// console.log("GTAG: " + process.env.VUE_APP_GA_TAG);

// if (store?.state?.username) {
//   console.log("UNAME : " + store.state.username);
//   set({ userId: store.state.username });
//   set({ EMPID: store.state.username });
// }
// import VueGTag, { set } from "vue-gtag";
// Vue.use(VueGTag, { config: { id: process.env.VUE_APP_GA_TAG } }, router);

// if (store?.state?.username) {
//   set({
//     userId: store.state.username,
//     user_id: store.state.username,
//     EMPID: store.state.username,
//   });
// }

/** dayjs and numeraljs */
import dayjs from "dayjs";
import th from "dayjs/locale/th";
import relativeTime from "dayjs/plugin/relativeTime";
import isToday from "dayjs/plugin/isToday";
import buddhistEra from "dayjs/plugin/buddhistEra";
import IsBetween from "dayjs/plugin/isBetween";
import numeral from "numeral";
import {GetProfileResponse} from "./types";

dayjs.locale(th);
dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(buddhistEra);
dayjs.extend(IsBetween);

const error = (text: any, header = null, persist = false) => {
    const message =
        typeof text?.response?.data === "string"
            ? text.response.data
            : text?.response?.data?.title
                ? text?.response?.data?.title
                : text?.response?.data?.errors
                    ? JSON.stringify(text?.response?.data?.errors)
                    : text?.response?.data?.message || text?.message || text;
    localToast.add({
        summary: header ?? "Error",
        detail: message,
        severity: "error",
        life: persist ? undefined : 5000,
    });
};
const warning = (input: any, persist = false) => {
    localToast.add({
        severity: "warn",
        summary: "Warning",
        detail: input,
        life: persist ? undefined : 5000,
    }); 
};

const success = (input: any, persist = false) => {
    localToast.add({
        severity: "success",
        summary: "Successfully",
        detail: input,
        life: persist ? undefined : 5000,
    });
};

const info = (input: any, persist = false) => {
    localToast.add({
        severity: "info",
        summary: "Successfully",
        detail: input,
        life: persist ? undefined : 5000,
    });
};


/** Sentry initial */
const getEnvironment = () => {
    const location = window.location.origin;
    return location.indexOf("apidev") >= 0
        ? "DEV"
        : location.indexOf("apiqas") >= 0
            ? "QAS"
            : location.indexOf("api.") >= 0
                ? "PRD"
                : "LCL";
};

const getLineLoginId = () => {
    const origin = window.location.origin;
    if (origin.indexOf("mosir.haadthip.com") >= 0) {
        return process.env.VUE_APP_LINE_CHANNEL_PRD ?? "N/A";
    } else if (origin.indexOf("mosirqas.haadthip.com") >= 0) {
        return process.env.VUE_APP_LINE_CHANNEL_QAS ?? "N/A";
    }
    return process.env.VUE_APP_LINE_CHANNEL_DEV ?? "N/A";
};

const onLogout = () => {
    useState().value.token = "";
    router.replace({name: "Login"});
};

const queryProfile = async () => {
    const state = useState();
    if (!state.value.token) return;
    const result = await axios.get<GetProfileResponse>("api/v1/server/profile");
    state.value.isAdmin = result.data.profile?.isAdmin ?? false;
};

const usePlugin = () => {
    return {
        dayjs,
        axios,
        success,
        warning,
        info,
        error,
        numeral,
        getLineLoginId,
        router,
        setupComponent,
        onLogout,
        setAxiosBearer,
        getEnvironment,
        toast: localToast,
        confirmation: localConfirm,
        queryProfile,
    };
};

export default usePlugin;
